__turbopack_context__.v({
  "border": "notificationDetails-module-scss-module__l2eE9W__border",
  "container": "notificationDetails-module-scss-module__l2eE9W__container",
  "content": "notificationDetails-module-scss-module__l2eE9W__content",
  "date": "notificationDetails-module-scss-module__l2eE9W__date",
  "fade-in-ux308bd": "notificationDetails-module-scss-module__l2eE9W__fade-in-ux308bd",
  "text": "notificationDetails-module-scss-module__l2eE9W__text",
  "title": "notificationDetails-module-scss-module__l2eE9W__title",
});
